module.exports = __webpack_public_path__ + "img/ico-scrap-white.84ef16a4.svg";